import { render } from "./connectionHQ.vue?vue&type=template&id=654afa04"
import script from "./connectionHQ.vue?vue&type=script&lang=js"
export * from "./connectionHQ.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__